class ASN {
  constructor(data) {
    this.asn = data.short_name;
    this.id = '' + data.asn;
    this.data = null;
    this.prefix = null;
    this.economy = data.economy; // ISO 3166-1 alpha-2, for retrieving data as a param, e.g. AU
    this.economyName = data.economyName; // full name of an economy, e.g. Australia
    this.region = data.region;
  }
}

export default ASN;
